import { Fragment, useEffect, useState } from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { useSelector } from "react-redux";
import CommunityMember from "../Communities/CommunityMember/CommunityMember";
import usersService from "../../../Axios/services/users.service";

export const MyCommunityUsers = (props: any) => {

    const { currentCommunityId, sidebarRouteData, currentCourse, currentPage } = useSelector((state: any) => state.main)
    
    const { me } = useSelector((state: any) => state.auth);
    const [users, setUsers] = useState<any>(undefined);

    const { path } = props;

    useEffect(() => {

        const getSHIHRUsers = async () => {
            const users = await usersService.getHRusers();
            setUsers(users)
        }

        const getUsersByCourse = () => {
            if (me?.participants) {
                const filteredUsers = me.participants;
                setUsers(filteredUsers)
            }
        }
        const getUsersByCommunity = () => {
            if (currentCommunityId && me?.connections) {
                const filteredUsers = me.connections
                    .filter((con: any) => con.roles.find((r: any) => r.communityId === currentCommunityId))
                setUsers(filteredUsers)
            }
        }
        const run = async () => {
            if (currentPage === 'coursePage' || currentPage === 'coursePageLibrary' || currentPage === 'EventPage') {
                if (me?.participants)
                    getUsersByCourse();
            }
            else if (currentPage === 'communityPage') {
                if (me?.connections) {
                    getUsersByCommunity()
                }
            }
            else {
                if (me?.connections)
                    setUsers(me.connections)
            }
        }

        if (path.includes('/shihr')) {
            getSHIHRUsers();
        } else {
            run();
        }

        return () => {
        }
    }, [currentPage, currentCourse, currentCommunityId, me?.connections , me?.participants]);

    return users && Array.isArray(users) ?
        <Fragment>
            {
                users.map((member: any, index: number) => (
                    <div key={index}>
                        <CommunityMember
                            currentCourse={currentCourse}
                            sidebarRouteData={sidebarRouteData}
                            member={member}
                            key={index}
                            onPopup={false}
                        />
                    </div>
                ))
            }
        </Fragment>
        :
        <Fragment>
            {
                Array.from(Array(4).keys()).map((e, i) => {
                    return <div className="py-3 px-5" key={i}>
                        <SkeletonTheme>
                            <div className="row flex-wrap justify-content-between">
                                <div className="col-2 d-flex justify-content-center">
                                    <Skeleton circle={true} height={60} width={60} />
                                </div>
                                <div className="col-9">
                                    <p className="m-0 p-0"><Skeleton height={10} width={100} /></p>
                                    <p className="m-0 p-0"><Skeleton height={5} width={130} /></p>
                                    <p className="m-0 p-0"><Skeleton height={5} width={120} /></p>
                                </div>
                            </div>
                        </SkeletonTheme>
                    </div>
                })
            }
        </Fragment>
}